import { combineReducers } from '@reduxjs/toolkit';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { rememberReducer } from 'redux-remember';
import account from './account/reducer';
import app from './app/reducer';
import bulk from './bulk/reducer';
// import collections from './collections/reducer'
import companies from './companies/reducer';
import company from './company/reducer';
import compose from './compose/reducer';
import contact from './contact/reducer';
import contacts from './contacts/reducer';
import flags from './flags/reducer';
import popups from './popups/reducer';
import pricing from './pricing/reducer';
import savedTab from './savedTab/reducer';
import searchCompany from './searchCompany/reducer';
import searchFilters from './searchFilters/reducer';
import settings from './settings/reducer';
import ugc from './ugc/reducer';
import user from './user/reducer';
import userActivity from './userActivity/reducer';
const AppReducer = rememberReducer(combineReducers({
    account,
    app,
    bulk,
    companies,
    company,
    compose,
    contact,
    contacts,
    flags,
    popups,
    pricing,
    savedTab,
    searchCompany,
    searchFilters,
    settings,
    ugc,
    user,
    userActivity,
}));
export const useAppDispatch = useDispatch;
export function useAppSelector(selectFn) {
    return useSelector(selectFn, shallowEqual);
}
export default AppReducer;
